const createVoucherPT = {
    key: 'Chave',
    productId: 'ID do produto',
    variantId: 'ID da variante',
    licenseId: 'ID da licença',
    maxSessions: 'Max usos',
    generate: 'Gerar chave'
}

export default createVoucherPT